import * as React from 'react';
import { Task } from './Task/Task';
import Grid from '@mui/material/Grid';
import { TasksControls } from './Controls/Controls';
import './Tasks.css';

function Tasks(props) {

    const [tasks, setTasks] = React.useState([]);
    const [infoLoaded, setInfoLoaded] = React.useState(false);

    React.useEffect(() => {
        fetch(`${props.url}/procesos-api/get-tasks`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
            },
            body: JSON.stringify({token: localStorage.getItem('token'),
                                  idProceso: null,
                                  userTasks: true, 
                                  caseTasks: false})
        })
        .then(res => res.json())
        .then(json => {
                setInfoLoaded(true)
                setTasks(json.tasks)
        })
    }, [props.url])

    return(
        <div className="tasks-container">
            <h1 className="titleMisProcesos">Tareas</h1>
            {infoLoaded ? <React.Fragment>
                            <TasksControls url={props.url}/>
                            <Grid container spacing={2}>
                                {tasks.map((element) => {
                                    return(
                                        <Task key={tasks.indexOf(element)} content={element} setOpenCaseInfo={props.setOpenCaseInfo}/> 
                                    )
                                })}
                            </Grid>
                            </React.Fragment>
                        : null}  
           
        </div>
        
    )
}

export { Tasks };